__turbopack_context__.v({
  "chassis": "DeskChassis-module__e2Z-8a__chassis",
});
